interface IconMapping {
  pattern: RegExp;
  icon: string;
}

const iconMappings: IconMapping[] = [
  // AOW (State pension age)
  {
    pattern: /aow[-\s]?leeftijd|bereikt\s+aow/i,
    icon: '/images/icons/timeline/aow.svg'
  },
  
  // Birthday/Child turning 18
  {
    pattern: /wordt\s+\d+\s+jaar|verjaardag|geboorte/i,
    icon: '/images/icons/timeline/verjaardag.svg'
  },
  
  // Property purchase
  {
    pattern: /aankoop\s+woning|woning\s+kopen|koop\s+huis/i,
    icon: '/images/icons/timeline/aankoop_woning.svg'
  },
  
  // End of mortgage term
  {
    pattern: /einde\s+looptijd\s+hypotheek|hypotheek\s+aflopen|aflossing\s+hypotheek/i,
    icon: '/images/icons/timeline/einde_looptijd_hypotheek.svg'
  },
  
  // End of fixed interest rate period (Einde RentevastPeriode)
  {
    pattern: /einde\s+rentevastperiode|einde\s+rvp|renteherziening|renteherzieningsdatum/i,
    icon: '/images/icons/timeline/einde_rvp.svg'
  },
  
  // Renovation/Improvement
  {
    pattern: /verbouwing|verbetering|renovatie|onderhoud\s+woning/i,
    icon: '/images/icons/timeline/verbouwing_verbetering.svg'
  },
  
  // Wealth/Capital/Financial
  {
    pattern: /vermogen|kapitaal|spaargeld|belegging|investering/i,
    icon: '/images/icons/timeline/vermogen.svg'
  },
  
  // Risk scan
  {
    pattern: /risicoscan|risicoanalyse|risico[-\s]?check/i,
    icon: '/images/icons/timeline/risicoscan.svg'
  }
];

/**
 * Default icon to use when no pattern matches
 */
const DEFAULT_ICON = '/images/icons/timeline/date.svg';

/**
 * Maps an gebeurtenis description to the most appropriate timeline icon
 * @param omschrijving - The event description text
 * @returns The path to the icon SVG file
 */
export const mapGebeurtenisToIcon = (omschrijving: string): string => {
  if (!omschrijving) {
    return DEFAULT_ICON;
  }

  // Find the first matching pattern
  const mapping = iconMappings.find(({ pattern }) => pattern.test(omschrijving));
  
  return mapping ? mapping.icon : DEFAULT_ICON;
};

